import { UPDATE_FILE_LIST, RECEIVE_FILE_LIST, RECEIVE_REMOVED_FILE, RECEIVE_API_FILE_LIST  } from '../actions/model_actions';
var {omit} = require('lodash')
const models_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    switch (action.type) {
        case UPDATE_FILE_LIST:
            return Object.assign({}, oldState, { [action.index]: action.file })
        case RECEIVE_API_FILE_LIST: {
            // The backend's list replaces ours, so approved and removed models
            // drop out. Uploads still on their way have no ID yet and aren't on
            // the backend, so they stay.
            const files = Object.values(action.fileList)
            const uploading = Object.values(oldState)
                .filter(file => !file._id && !files.some(({ name }) => name === file.name))
            return Object.assign({}, [...files, ...uploading])
        }
        case RECEIVE_FILE_LIST:
            return oldState
        case RECEIVE_REMOVED_FILE: 
            return omit(oldState, action.index)
        default:
            return oldState;
    }
};

export default models_reducer;